import Vue from "vue"
import {APIHOST} from "@/settings/server";
import $store from "@/store"
import axios from "axios";

class MailService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }

    getDistributionDataTable({skip, limit, sort, desc, client, region, area, postIndex, isDistributed, isPrinted, isPosted,
                     isPerformed, isTransferNotified, isTransferCompleted, isExpress, start, end })
    {
        return Vue.axios.get(`${APIHOST}/api/distributiondatatable`, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            params: {
                limit: limit,
                skip: skip,
                sort: sort,
                desc: desc,
                client: client ? client.id : null,
                region: region ? region.id : null,
                area: area ? area.id : null,
                postIndex: postIndex ? postIndex : null,
                isDistributed: typeof (isDistributed) === "boolean" ? isDistributed : null,
                isPrinted: typeof (isPrinted) === "boolean" ? isPrinted : null,
                isPosted: typeof (isPosted) === "boolean" ? isPosted : null,
                isPerformed: typeof (isPerformed) === "boolean" ? isPerformed : null,
                isTransferNotified: typeof (isTransferNotified) === "boolean" ? isTransferNotified : null,
                isTransferCompleted: typeof (isTransferCompleted) === "boolean" ? isTransferCompleted : null,
                isExpress: typeof (isExpress) === "boolean" ? isExpress : null,
                start: start ? start.format("YYYY-MM-DD") : null,
                end: end ? end.format("YYYY-MM-DD") : null
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }
    getMonitoringDataTable({skip, limit, sort, desc, client, region, area, unit, postIndex, isDistributed, isPrinted, isPosted,
                               isPerformed, isTransferNotified, isTransferCompleted, isExpress, performTypes, start, end })
    {
        const requestBody = {
            limit: limit,
            skip: skip,
            sort: sort,
            desc: desc,
            client: client ? client.id : null,
            region: region ? region.id : null,
            area: area ? area.id : null,
            unit: unit ? unit.id : null,
            postIndex: postIndex ? postIndex : null,
            isDistributed: typeof (isDistributed) === "boolean" ? isDistributed : null,
            isPrinted: typeof (isPrinted) === "boolean" ? isPrinted : null,
            isPosted: typeof (isPosted) === "boolean" ? isPosted : null,
            isPerformed: typeof (isPerformed) === "boolean" ? isPerformed : null,
            isTransferNotified: typeof (isTransferNotified) === "boolean" ? isTransferNotified : null,
            isTransferCompleted: typeof (isTransferCompleted) === "boolean" ? isTransferCompleted : null,
            isExpress: typeof (isExpress) === "boolean" ? isExpress : null,
            performTypes: performTypes,
            start: start ? start.format("YYYY-MM-DD") : null,
            end: end ? end.format("YYYY-MM-DD") : null
        }
        return Vue.axios.post(`${APIHOST}/api/monitoringdatatable`, requestBody,{
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    getPrintDataTable({skip, limit, sort, desc, client, region, area, postIndex, isDistributed, isPrinted, isPosted,
                          isPerformed, isTransferNotified, isTransferCompleted, isExpress, performTypes, start, end })
    {
        const requestBody = {
            limit: limit,
            skip: skip,
            sort: sort,
            desc: desc,
            client: client ? client.id : null,
            region: region ? region.id : null,
            area: area ? area.id : null,
            postIndex: postIndex ? postIndex : null,
            isDistributed: typeof (isDistributed) === "boolean" ? isDistributed : null,
            isPrinted: typeof (isPrinted) === "boolean" ? isPrinted : null,
            isPosted: typeof (isPosted) === "boolean" ? isPosted : null,
            isPerformed: typeof (isPerformed) === "boolean" ? isPerformed : null,
            isTransferNotified: typeof (isTransferNotified) === "boolean" ? isTransferNotified : null,
            isTransferCompleted: typeof (isTransferCompleted) === "boolean" ? isTransferCompleted : null,
            isExpress: typeof (isExpress) === "boolean" ? isExpress : null,
            performTypes: performTypes,
            start: start ? start.format("YYYY-MM-DD") : null,
            end: end ? end.format("YYYY-MM-DD") : null
        }
        return Vue.axios.post(`${APIHOST}/api/printdatatable`, requestBody,{
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    downloadExcel({limit, skip, sort, desc, client, region, area, unit, postIndex, isDistributed, isPrinted, isPosted,
                      isPerformed, isTransferNotified, isTransferCompleted, isExpress, performTypes,start, end, telegramId }) {
        const requestBody = {
            limit: limit,
            skip: skip,
            sort: sort,
            desc: desc,
            client: client ? client.id : null,
            region: region ? region.id : null,
            area: area ? area.id : null,
            unit: unit ? unit.id : null,
            postIndex: postIndex ? postIndex : null,
            isDistributed: typeof (isDistributed) === "boolean" ? isDistributed : null,
            isPrinted: typeof (isPrinted) === "boolean" ? isPrinted : null,
            isPosted: typeof (isPosted) === "boolean" ? isPosted : null,
            isPerformed: typeof (isPerformed) === "boolean" ? isPerformed : null,
            isTransferNotified: typeof (isTransferNotified) === "boolean" ? isTransferNotified : null,
            isTransferCompleted: typeof (isTransferCompleted) === "boolean" ? isTransferCompleted : null,
            isExpress: typeof (isExpress) === "boolean" ? isExpress : null,
            performTypes: performTypes,
            start: start ? start.format("YYYY-MM-DD") : null,
            end: end ? end.format("YYYY-MM-DD") : null,
            telegramId: telegramId ? telegramId : null
        }
        return Vue.axios.post(`${APIHOST}/api/maildatatableexcel`, requestBody,{
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    get(uid) {
        return Vue.axios.get(`${APIHOST}/api/mail`, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: uid
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    getByUids(uids) {
        return Vue.axios.post(`${APIHOST}/api/GetMailByUid`, {
            uids
        }, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            }
        })
    }


    updateMailStatus(uid) {
        return Vue.axios.get(`${APIHOST}/api/SyncStatus`, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            params: {
                uid: uid
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    getBranchMailRegionUids({ client, start, end, selectedRegion, selectedFilter, isAllClientsSelected, clients }) {
        const requestBody = {
            client: client ? client.id : null,
            start: start ? start.format("YYYY-MM-DD") : null,
            end: end ? end.format("YYYY-MM-DD") : null,
            region: selectedRegion ? selectedRegion : null,
            selectedFilter: selectedFilter ? selectedFilter : null,
            isAllClientsSelected: isAllClientsSelected,
            clients: clients
        };

        return Vue.axios.post(`${APIHOST}/api/RegionMailFields`, requestBody, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    getTaskPerformanceRegionUids({ client, start, end, selectedRegion, selectedFilter, isAllClientsSelected, clients, isArchive}) {
        const requestBody = {
            client: client ? client.id : null,
            start: start ? start.format("YYYY-MM-DD") : null,
            end: end ? end.format("YYYY-MM-DD") : null,
            region: selectedRegion ? selectedRegion : null,
            selectedFilter: selectedFilter ? selectedFilter : null,
            isAllClientsSelected: isAllClientsSelected,
            clients: clients,
            isArchive: isArchive
        };

        return Vue.axios.post(`${APIHOST}/api/TaskPerformanceRegionMailFields`, requestBody, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    getTaskPerformanceAreaUids({ client, start, end, selectedRegion, selectedArea, selectedFilter, isAllClientsSelected, clients, isArchive }) {
        const requestBody = {
            client: client ? client.id : null,
            start: start ? start.format("YYYY-MM-DD") : null,
            end: end ? end.format("YYYY-MM-DD") : null,
            region: selectedRegion ? selectedRegion : null,
            area: selectedArea ? selectedArea : null,
            selectedFilter: selectedFilter ? selectedFilter : null,
            isAllClientsSelected: isAllClientsSelected,
            clients: clients,
            isArchive: isArchive
        };

        return Vue.axios.post(`${APIHOST}/api/TaskPerformanceAreaMailFields`, requestBody, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    getClientMailRegionUids({client, start, end, selectedFilter}) {
        const requestBody = {
            client: client,
            start: start ? start.format("YYYY-MM-DD") : null,
            end: end ? end.format("YYYY-MM-DD") : null,
            selectedFilter: selectedFilter ? selectedFilter : null
        };

        return Vue.axios.post(`${APIHOST}/api/ClientsMailFields`, requestBody, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    getBranchMailAreaUids({ client, start, end, selectedArea, selectedRegion, selectedFilter, isAllClientsSelected, clients }) {
        const requestBody = {
            client: client ? client.id : null,
            start: start ? start.format("YYYY-MM-DD") : null,
            end: end ? end.format("YYYY-MM-DD") : null,
            region: selectedRegion ? selectedRegion : null,
            area: selectedArea ? selectedArea : null,
            selectedFilter: selectedFilter ? selectedFilter : null,
            isAllClientsSelected: isAllClientsSelected,
            clients: clients
        };

        return Vue.axios.post(`${APIHOST}/api/AreaMailFields`, requestBody, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    getBranchMailPostIndexUids({ client, start, end, selectedRegion, selectedArea, selectedPostCode, selectedFilter, isAllClientsSelected, clients }) {
        const requestBody = {
            client: client ? client.id : null,
            start: start ? start.format("YYYY-MM-DD") : null,
            end: end ? end.format("YYYY-MM-DD") : null,
            region: selectedRegion ? selectedRegion : null,
            area: selectedArea ? selectedArea : null,
            postcode: selectedPostCode ? selectedPostCode : null,
            selectedFilter: selectedFilter ? selectedFilter : null,
            isAllClientsSelected: isAllClientsSelected,
            clients: clients
        };

        return Vue.axios.post(`${APIHOST}/api/PostIndexMailFields`, requestBody, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    getSendHistory(id) {
        return Vue.axios.get(`${APIHOST}/api/MailSendHistory`, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: id
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }
    getNotPrintedCountsByClient() {
        return Vue.axios.get(`${APIHOST}/api/MailNotPrintedCount`, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    checkMailArrivedByClient(clients) {
        return Vue.axios.post(`${APIHOST}/api/CheckMailArrived`, clients, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    getPdfPath(mail) {
        return `${APIHOST}/api/MailPdf/${mail.uid}`
    }

    getHistories(mail) {
        let parameter = ''
        if (mail)
        {
            if (mail?.uid && mail.uid !== '') {
                parameter = mail.uid
            } else {
                parameter = mail
            }
        }

        return Vue.axios.get(`${APIHOST}/api/MailHistory`, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: parameter
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    perform({mail, performType, performDate, note, recipient}) {
        return Vue.axios.put(`${APIHOST}/api/mailperform`, {
            Type: performType.id,
            Note: note,
            PerformDate: performDate ? performDate.format("YYYY-MM-DD") : null,
            Recipient: recipient ? recipient : null
        }, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: mail.uid
            }
        })
    }

    performMails({mails, performType, note, client, postCode}) {
        return Vue.axios.put(`${APIHOST}/api/mailperform`, {
            Type: performType.id,
            client: client ? client.id : null,
            Note: note,
            Mails: mails,
            PostCode: postCode
        }, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
        })
    }

    unsetPostPackage(mailUid, regionId, areaId, postIndexId) {
        return Vue.axios.put(`${APIHOST}/api/MailUnsetPostPackage`, {}, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: mailUid,
                regionId: regionId,
                areaId: areaId,
                postIndex: postIndexId
            }
        })
    }

    setPostPackage({postPackage, mailUid}) {
        return Vue.axios.put(`${APIHOST}/api/PostPackageMail`, {
            MailUid: mailUid
        }, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: postPackage.uid
            }
        })
    }

    deleteFromPostPackage(mail) {
        return Vue.axios.delete(`${APIHOST}/api/PostPackageMail`, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: mail.uid
            }
        })
    }

    setAncientMail({mailUid}) {
        return Vue.axios.post(`${APIHOST}/api/AncientMail`, {
            mailUid: mailUid
        }, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            }
        })
    }

    deletePerform(id) {
        return Vue.axios.delete(`${APIHOST}/api/MailPerform`, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: id
            }
        })
    }

}

export default new MailService()
